import { render, staticRenderFns } from "./AddClinicModal.vue?vue&type=template&id=04b50bc4&scoped=true&"
import script from "./AddClinicModal.vue?vue&type=script&lang=js&"
export * from "./AddClinicModal.vue?vue&type=script&lang=js&"
import style0 from "./AddClinicModal.vue?vue&type=style&index=0&id=04b50bc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b50bc4",
  null
  
)

export default component.exports